module.exports = __webpack_public_path__ + "img/banner_1.b1054e06.jpg";